import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCustomer } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/customer/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.setItem("pnp_customer", "1");
        setCustomer(data);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true, state: { user: data } });
      } catch (e) {
        console.debug("auth callback failed", e?.message);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setCustomer]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 text-brand-red animate-spin" />
    </div>
  );
}
